/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * herald/v1/user_notifications.proto
 * OpenAPI spec version: version not set
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import * as axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

import type {
  ListUserNotifications2Params,
  ListUserNotificationsParams,
  RpcStatus,
  UserNotificationServiceMarkNotificationsAsReadBodyBody,
  UserNotificationServiceMarkNotificationsTillNowReadBodyBody,
  V1GetUserUnreadNotificationCountForWorkspaceResponse,
  V1ListUserNotificationsResponse,
  V1MarkNotificationsAsReadResponse,
  V1MarkNotificationsTillNowReadResponse,
} from '../models';

/**
 * @summary ListUserNotifications returns a paginated list of notifications for the authenticated user.
 */
export const listUserNotifications2 = (
  organization: string,
  params?: ListUserNotifications2Params,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListUserNotificationsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/notifications`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getListUserNotifications2QueryKey = (
  organization?: string,
  params?: ListUserNotifications2Params,
) => {
  return [
    `/api/v1/organizations/${organization}/notifications`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListUserNotifications2QueryOptions = <
  TData = Awaited<ReturnType<typeof listUserNotifications2>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  params?: ListUserNotifications2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listUserNotifications2>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListUserNotifications2QueryKey(organization, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listUserNotifications2>>
  > = ({ signal }) =>
    listUserNotifications2(organization, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!organization,
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listUserNotifications2>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListUserNotifications2QueryResult = NonNullable<
  Awaited<ReturnType<typeof listUserNotifications2>>
>;
export type ListUserNotifications2QueryError = AxiosError<RpcStatus>;

export function useListUserNotifications2<
  TData = Awaited<ReturnType<typeof listUserNotifications2>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  params: undefined | ListUserNotifications2Params,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listUserNotifications2>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUserNotifications2>>,
          TError,
          Awaited<ReturnType<typeof listUserNotifications2>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListUserNotifications2<
  TData = Awaited<ReturnType<typeof listUserNotifications2>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  params?: ListUserNotifications2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listUserNotifications2>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUserNotifications2>>,
          TError,
          Awaited<ReturnType<typeof listUserNotifications2>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListUserNotifications2<
  TData = Awaited<ReturnType<typeof listUserNotifications2>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  params?: ListUserNotifications2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listUserNotifications2>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary ListUserNotifications returns a paginated list of notifications for the authenticated user.
 */

export function useListUserNotifications2<
  TData = Awaited<ReturnType<typeof listUserNotifications2>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  params?: ListUserNotifications2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listUserNotifications2>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListUserNotifications2QueryOptions(
    organization,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * This server-streaming RPC delivers notifications as they are created,
providing live updates with minimal latency. The stream remains open
indefinitely, delivering new notifications as they occur.

Reconnection support: Clients can pass the Last-Event-ID HTTP header
to resume the stream from where they left off. The server will replay
any missed notifications before switching to live mode.
 * @summary Stream real-time user notifications via SSE.
 */
export const streamUserNotifications2 = (
  organization: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Blob>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/notifications/stream`,
    {
      responseType: 'blob',
      ...options,
    },
  );
};

export const getStreamUserNotifications2QueryKey = (organization?: string) => {
  return [
    `/api/v1/organizations/${organization}/notifications/stream`,
  ] as const;
};

export const getStreamUserNotifications2QueryOptions = <
  TData = Awaited<ReturnType<typeof streamUserNotifications2>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof streamUserNotifications2>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getStreamUserNotifications2QueryKey(organization);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof streamUserNotifications2>>
  > = ({ signal }) =>
    streamUserNotifications2(organization, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!organization,
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof streamUserNotifications2>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type StreamUserNotifications2QueryResult = NonNullable<
  Awaited<ReturnType<typeof streamUserNotifications2>>
>;
export type StreamUserNotifications2QueryError = AxiosError<RpcStatus>;

export function useStreamUserNotifications2<
  TData = Awaited<ReturnType<typeof streamUserNotifications2>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof streamUserNotifications2>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof streamUserNotifications2>>,
          TError,
          Awaited<ReturnType<typeof streamUserNotifications2>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useStreamUserNotifications2<
  TData = Awaited<ReturnType<typeof streamUserNotifications2>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof streamUserNotifications2>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof streamUserNotifications2>>,
          TError,
          Awaited<ReturnType<typeof streamUserNotifications2>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useStreamUserNotifications2<
  TData = Awaited<ReturnType<typeof streamUserNotifications2>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof streamUserNotifications2>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Stream real-time user notifications via SSE.
 */

export function useStreamUserNotifications2<
  TData = Awaited<ReturnType<typeof streamUserNotifications2>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof streamUserNotifications2>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getStreamUserNotifications2QueryOptions(
    organization,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary MarkNotificationsTillNowRead marks all notifications created at or before
the given timestamp as read.
 */
export const markNotificationsTillNowRead2 = (
  organization: string,
  userNotificationServiceMarkNotificationsTillNowReadBodyBody: UserNotificationServiceMarkNotificationsTillNowReadBodyBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1MarkNotificationsTillNowReadResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/notifications:markAllRead`,
    userNotificationServiceMarkNotificationsTillNowReadBodyBody,
    options,
  );
};

export const getMarkNotificationsTillNowRead2MutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markNotificationsTillNowRead2>>,
    TError,
    {
      organization: string;
      data: UserNotificationServiceMarkNotificationsTillNowReadBodyBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markNotificationsTillNowRead2>>,
  TError,
  {
    organization: string;
    data: UserNotificationServiceMarkNotificationsTillNowReadBodyBody;
  },
  TContext
> => {
  const mutationKey = ['markNotificationsTillNowRead2'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markNotificationsTillNowRead2>>,
    {
      organization: string;
      data: UserNotificationServiceMarkNotificationsTillNowReadBodyBody;
    }
  > = props => {
    const { organization, data } = props ?? {};

    return markNotificationsTillNowRead2(organization, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkNotificationsTillNowRead2MutationResult = NonNullable<
  Awaited<ReturnType<typeof markNotificationsTillNowRead2>>
>;
export type MarkNotificationsTillNowRead2MutationBody =
  UserNotificationServiceMarkNotificationsTillNowReadBodyBody;
export type MarkNotificationsTillNowRead2MutationError = AxiosError<RpcStatus>;

/**
 * @summary MarkNotificationsTillNowRead marks all notifications created at or before
the given timestamp as read.
 */
export const useMarkNotificationsTillNowRead2 = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof markNotificationsTillNowRead2>>,
      TError,
      {
        organization: string;
        data: UserNotificationServiceMarkNotificationsTillNowReadBodyBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof markNotificationsTillNowRead2>>,
  TError,
  {
    organization: string;
    data: UserNotificationServiceMarkNotificationsTillNowReadBodyBody;
  },
  TContext
> => {
  const mutationOptions =
    getMarkNotificationsTillNowRead2MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary MarkNotificationsAsRead marks the given notifications as read.
 */
export const markNotificationsAsRead2 = (
  organization: string,
  userNotificationServiceMarkNotificationsAsReadBodyBody: UserNotificationServiceMarkNotificationsAsReadBodyBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1MarkNotificationsAsReadResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/notifications:markRead`,
    userNotificationServiceMarkNotificationsAsReadBodyBody,
    options,
  );
};

export const getMarkNotificationsAsRead2MutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markNotificationsAsRead2>>,
    TError,
    {
      organization: string;
      data: UserNotificationServiceMarkNotificationsAsReadBodyBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markNotificationsAsRead2>>,
  TError,
  {
    organization: string;
    data: UserNotificationServiceMarkNotificationsAsReadBodyBody;
  },
  TContext
> => {
  const mutationKey = ['markNotificationsAsRead2'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markNotificationsAsRead2>>,
    {
      organization: string;
      data: UserNotificationServiceMarkNotificationsAsReadBodyBody;
    }
  > = props => {
    const { organization, data } = props ?? {};

    return markNotificationsAsRead2(organization, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkNotificationsAsRead2MutationResult = NonNullable<
  Awaited<ReturnType<typeof markNotificationsAsRead2>>
>;
export type MarkNotificationsAsRead2MutationBody =
  UserNotificationServiceMarkNotificationsAsReadBodyBody;
export type MarkNotificationsAsRead2MutationError = AxiosError<RpcStatus>;

/**
 * @summary MarkNotificationsAsRead marks the given notifications as read.
 */
export const useMarkNotificationsAsRead2 = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof markNotificationsAsRead2>>,
      TError,
      {
        organization: string;
        data: UserNotificationServiceMarkNotificationsAsReadBodyBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof markNotificationsAsRead2>>,
  TError,
  {
    organization: string;
    data: UserNotificationServiceMarkNotificationsAsReadBodyBody;
  },
  TContext
> => {
  const mutationOptions = getMarkNotificationsAsRead2MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary ListUserNotifications returns a paginated list of notifications for the authenticated user.
 */
export const listUserNotifications = (
  organization: string,
  workspace: string,
  params?: ListUserNotificationsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListUserNotificationsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/notifications`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getListUserNotificationsQueryKey = (
  organization?: string,
  workspace?: string,
  params?: ListUserNotificationsParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/notifications`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListUserNotificationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listUserNotifications>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListUserNotificationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listUserNotifications>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListUserNotificationsQueryKey(organization, workspace, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listUserNotifications>>
  > = ({ signal }) =>
    listUserNotifications(organization, workspace, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listUserNotifications>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListUserNotificationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listUserNotifications>>
>;
export type ListUserNotificationsQueryError = AxiosError<RpcStatus>;

export function useListUserNotifications<
  TData = Awaited<ReturnType<typeof listUserNotifications>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params: undefined | ListUserNotificationsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listUserNotifications>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUserNotifications>>,
          TError,
          Awaited<ReturnType<typeof listUserNotifications>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListUserNotifications<
  TData = Awaited<ReturnType<typeof listUserNotifications>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListUserNotificationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listUserNotifications>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUserNotifications>>,
          TError,
          Awaited<ReturnType<typeof listUserNotifications>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListUserNotifications<
  TData = Awaited<ReturnType<typeof listUserNotifications>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListUserNotificationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listUserNotifications>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary ListUserNotifications returns a paginated list of notifications for the authenticated user.
 */

export function useListUserNotifications<
  TData = Awaited<ReturnType<typeof listUserNotifications>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListUserNotificationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listUserNotifications>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListUserNotificationsQueryOptions(
    organization,
    workspace,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * This server-streaming RPC delivers notifications as they are created,
providing live updates with minimal latency. The stream remains open
indefinitely, delivering new notifications as they occur.

Reconnection support: Clients can pass the Last-Event-ID HTTP header
to resume the stream from where they left off. The server will replay
any missed notifications before switching to live mode.
 * @summary Stream real-time user notifications via SSE.
 */
export const streamUserNotifications = (
  organization: string,
  workspace: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Blob>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/notifications/stream`,
    {
      responseType: 'blob',
      ...options,
    },
  );
};

export const getStreamUserNotificationsQueryKey = (
  organization?: string,
  workspace?: string,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/notifications/stream`,
  ] as const;
};

export const getStreamUserNotificationsQueryOptions = <
  TData = Awaited<ReturnType<typeof streamUserNotifications>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof streamUserNotifications>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getStreamUserNotificationsQueryKey(organization, workspace);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof streamUserNotifications>>
  > = ({ signal }) =>
    streamUserNotifications(organization, workspace, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof streamUserNotifications>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type StreamUserNotificationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof streamUserNotifications>>
>;
export type StreamUserNotificationsQueryError = AxiosError<RpcStatus>;

export function useStreamUserNotifications<
  TData = Awaited<ReturnType<typeof streamUserNotifications>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof streamUserNotifications>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof streamUserNotifications>>,
          TError,
          Awaited<ReturnType<typeof streamUserNotifications>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useStreamUserNotifications<
  TData = Awaited<ReturnType<typeof streamUserNotifications>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof streamUserNotifications>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof streamUserNotifications>>,
          TError,
          Awaited<ReturnType<typeof streamUserNotifications>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useStreamUserNotifications<
  TData = Awaited<ReturnType<typeof streamUserNotifications>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof streamUserNotifications>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Stream real-time user notifications via SSE.
 */

export function useStreamUserNotifications<
  TData = Awaited<ReturnType<typeof streamUserNotifications>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof streamUserNotifications>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getStreamUserNotificationsQueryOptions(
    organization,
    workspace,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary MarkNotificationsTillNowRead marks all notifications created at or before
the given timestamp as read.
 */
export const markNotificationsTillNowRead = (
  organization: string,
  workspace: string,
  userNotificationServiceMarkNotificationsTillNowReadBodyBody: UserNotificationServiceMarkNotificationsTillNowReadBodyBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1MarkNotificationsTillNowReadResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/notifications:markAllRead`,
    userNotificationServiceMarkNotificationsTillNowReadBodyBody,
    options,
  );
};

export const getMarkNotificationsTillNowReadMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markNotificationsTillNowRead>>,
    TError,
    {
      organization: string;
      workspace: string;
      data: UserNotificationServiceMarkNotificationsTillNowReadBodyBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markNotificationsTillNowRead>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: UserNotificationServiceMarkNotificationsTillNowReadBodyBody;
  },
  TContext
> => {
  const mutationKey = ['markNotificationsTillNowRead'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markNotificationsTillNowRead>>,
    {
      organization: string;
      workspace: string;
      data: UserNotificationServiceMarkNotificationsTillNowReadBodyBody;
    }
  > = props => {
    const { organization, workspace, data } = props ?? {};

    return markNotificationsTillNowRead(
      organization,
      workspace,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkNotificationsTillNowReadMutationResult = NonNullable<
  Awaited<ReturnType<typeof markNotificationsTillNowRead>>
>;
export type MarkNotificationsTillNowReadMutationBody =
  UserNotificationServiceMarkNotificationsTillNowReadBodyBody;
export type MarkNotificationsTillNowReadMutationError = AxiosError<RpcStatus>;

/**
 * @summary MarkNotificationsTillNowRead marks all notifications created at or before
the given timestamp as read.
 */
export const useMarkNotificationsTillNowRead = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof markNotificationsTillNowRead>>,
      TError,
      {
        organization: string;
        workspace: string;
        data: UserNotificationServiceMarkNotificationsTillNowReadBodyBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof markNotificationsTillNowRead>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: UserNotificationServiceMarkNotificationsTillNowReadBodyBody;
  },
  TContext
> => {
  const mutationOptions =
    getMarkNotificationsTillNowReadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary MarkNotificationsAsRead marks the given notifications as read.
 */
export const markNotificationsAsRead = (
  organization: string,
  workspace: string,
  userNotificationServiceMarkNotificationsAsReadBodyBody: UserNotificationServiceMarkNotificationsAsReadBodyBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1MarkNotificationsAsReadResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/notifications:markRead`,
    userNotificationServiceMarkNotificationsAsReadBodyBody,
    options,
  );
};

export const getMarkNotificationsAsReadMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markNotificationsAsRead>>,
    TError,
    {
      organization: string;
      workspace: string;
      data: UserNotificationServiceMarkNotificationsAsReadBodyBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markNotificationsAsRead>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: UserNotificationServiceMarkNotificationsAsReadBodyBody;
  },
  TContext
> => {
  const mutationKey = ['markNotificationsAsRead'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markNotificationsAsRead>>,
    {
      organization: string;
      workspace: string;
      data: UserNotificationServiceMarkNotificationsAsReadBodyBody;
    }
  > = props => {
    const { organization, workspace, data } = props ?? {};

    return markNotificationsAsRead(organization, workspace, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkNotificationsAsReadMutationResult = NonNullable<
  Awaited<ReturnType<typeof markNotificationsAsRead>>
>;
export type MarkNotificationsAsReadMutationBody =
  UserNotificationServiceMarkNotificationsAsReadBodyBody;
export type MarkNotificationsAsReadMutationError = AxiosError<RpcStatus>;

/**
 * @summary MarkNotificationsAsRead marks the given notifications as read.
 */
export const useMarkNotificationsAsRead = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof markNotificationsAsRead>>,
      TError,
      {
        organization: string;
        workspace: string;
        data: UserNotificationServiceMarkNotificationsAsReadBodyBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof markNotificationsAsRead>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: UserNotificationServiceMarkNotificationsAsReadBodyBody;
  },
  TContext
> => {
  const mutationOptions = getMarkNotificationsAsReadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary GetUserUnreadNotificationCountForWorkspace returns the count of unread
notifications for the authenticated user within a specific workspace.
 */
export const getUserUnreadNotificationCountForWorkspace = (
  organization: string,
  workspace: string,
  options?: AxiosRequestConfig,
): Promise<
  AxiosResponse<V1GetUserUnreadNotificationCountForWorkspaceResponse>
> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/notifications:unreadCount`,
    options,
  );
};

export const getGetUserUnreadNotificationCountForWorkspaceQueryKey = (
  organization?: string,
  workspace?: string,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/notifications:unreadCount`,
  ] as const;
};

export const getGetUserUnreadNotificationCountForWorkspaceQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getUserUnreadNotificationCountForWorkspace>
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserUnreadNotificationCountForWorkspace>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetUserUnreadNotificationCountForWorkspaceQueryKey(
      organization,
      workspace,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserUnreadNotificationCountForWorkspace>>
  > = ({ signal }) =>
    getUserUnreadNotificationCountForWorkspace(organization, workspace, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserUnreadNotificationCountForWorkspace>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserUnreadNotificationCountForWorkspaceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserUnreadNotificationCountForWorkspace>>
>;
export type GetUserUnreadNotificationCountForWorkspaceQueryError =
  AxiosError<RpcStatus>;

export function useGetUserUnreadNotificationCountForWorkspace<
  TData = Awaited<
    ReturnType<typeof getUserUnreadNotificationCountForWorkspace>
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserUnreadNotificationCountForWorkspace>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getUserUnreadNotificationCountForWorkspace>
          >,
          TError,
          Awaited<ReturnType<typeof getUserUnreadNotificationCountForWorkspace>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserUnreadNotificationCountForWorkspace<
  TData = Awaited<
    ReturnType<typeof getUserUnreadNotificationCountForWorkspace>
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserUnreadNotificationCountForWorkspace>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getUserUnreadNotificationCountForWorkspace>
          >,
          TError,
          Awaited<ReturnType<typeof getUserUnreadNotificationCountForWorkspace>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserUnreadNotificationCountForWorkspace<
  TData = Awaited<
    ReturnType<typeof getUserUnreadNotificationCountForWorkspace>
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserUnreadNotificationCountForWorkspace>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary GetUserUnreadNotificationCountForWorkspace returns the count of unread
notifications for the authenticated user within a specific workspace.
 */

export function useGetUserUnreadNotificationCountForWorkspace<
  TData = Awaited<
    ReturnType<typeof getUserUnreadNotificationCountForWorkspace>
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserUnreadNotificationCountForWorkspace>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetUserUnreadNotificationCountForWorkspaceQueryOptions(
      organization,
      workspace,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
